import { FC } from "react";

import Box from "@mui/material/Box";
import { getEmailFooterHtml } from "@simplyk/common";

import { useLocaleContext } from "@/common/contexts/LocaleContext";

export interface EmailPreviewBodyCardProps {
  bodyHtml: string;
  backgroundColor?: string | null;
}

export const EmailPreviewBodyCard: FC<EmailPreviewBodyCardProps> = ({ bodyHtml, backgroundColor }) => {
  const { locale } = useLocaleContext();

  const footerHtml = getEmailFooterHtml({
    locale,
    unsubscribeUrl: process.env.NEXT_PUBLIC_FRONTEND_URL as string,
    backgroundColor: backgroundColor ?? undefined,
  });

  return (
    <Box
      sx={(theme) => ({
        width: "100%",
        maxWidth: 427,
        borderRadius: theme.radius(1),
        backgroundColor: "white",
        overflow: "hidden",
      })}
    >
      <Box sx={{ paddingX: 3, paddingY: 2, wordBreak: "break-word", overflowWrap: "break-word" }}>
        <div dangerouslySetInnerHTML={{ __html: bodyHtml }} />
      </Box>
      <div dangerouslySetInnerHTML={{ __html: footerHtml }} />
    </Box>
  );
};
